<template>
  <header class="header">
    <div class="wrapper">
      <div class="left">
        <router-link to="/" class="logo">
          <div class="title medium">BlockWrld</div>
        </router-link>
      </div>
      <div class="nav">
        <template v-for="item in $parent.nav">
          <router-link class="desc medium" :key="item.id" :to="item.path">
            {{ $t(item.title) }}
          </router-link>
        </template>
        <div v-if="currencyCodes && currencyCodes.length > 1">
          <Select2
            :model-value="$parent.currency"
            @select="changeCurrency($event.text)"
            @change="changeCurrency($event)"
            :settings="{
              minimumResultsForSearch: -1,
              dropdownCssClass: 'header-select2-dropdown',
            }"
            :options="currencyCodes"
          />
        </div>
      </div>
      <div class="right">
        <router-link to="/balance" class="balance" v-if="$parent.isAuth">
          <img src="./../images/coin.svg" class="img" />
          <div class="desc medium">Balance</div>
        </router-link>
        <router-link to="/cart" class="icon-button" v-if="$parent.isAuth">
          <svg
            width="25"
            height="26"
            viewBox="0 0 25 26"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clip-path="url(#clip0_148_824)">
              <path
                d="M23.6594 4.74688C23.3664 4.39525 22.9995 4.11245 22.5849 3.91856C22.1703 3.72467 21.7181 3.62445 21.2604 3.625H4.41875L4.375 3.25938C4.28547 2.4994 3.92019 1.79868 3.34843 1.29008C2.77666 0.781486 2.03815 0.50036 1.27292 0.500004L1.04167 0.500004C0.7654 0.500004 0.500448 0.609751 0.305097 0.805101C0.109747 1.00045 0 1.2654 0 1.54167C0 1.81794 0.109747 2.08289 0.305097 2.27824C0.500448 2.47359 0.7654 2.58334 1.04167 2.58334H1.27292C1.52806 2.58337 1.77431 2.67704 1.96497 2.84658C2.15563 3.01612 2.27744 3.24974 2.30729 3.50313L3.74063 15.6906C3.88943 16.9581 4.49841 18.1269 5.45199 18.975C6.40556 19.8232 7.63735 20.2917 8.91354 20.2917H19.7917C20.0679 20.2917 20.3329 20.1819 20.5282 19.9866C20.7236 19.7912 20.8333 19.5263 20.8333 19.25C20.8333 18.9737 20.7236 18.7088 20.5282 18.5134C20.3329 18.3181 20.0679 18.2083 19.7917 18.2083H8.91354C8.26881 18.2065 7.64042 18.0053 7.11452 17.6324C6.58862 17.2594 6.19095 16.7329 5.97604 16.125H18.3927C19.6138 16.1251 20.7962 15.6961 21.7332 14.913C22.6701 14.1298 23.3021 13.0424 23.5188 11.8406L24.3365 7.30521C24.4181 6.85522 24.3997 6.39278 24.2827 5.95067C24.1657 5.50855 23.9529 5.09758 23.6594 4.74688ZM22.2917 6.93542L21.4729 11.4708C21.3428 12.1927 20.963 12.8458 20.3999 13.3158C19.8367 13.7858 19.1262 14.0428 18.3927 14.0417H5.64479L4.66458 5.70834H21.2604C21.4134 5.70742 21.5648 5.74023 21.7037 5.80444C21.8426 5.86864 21.9656 5.96266 22.0641 6.0798C22.1625 6.19695 22.234 6.33435 22.2733 6.48223C22.3126 6.63011 22.3189 6.78484 22.2917 6.93542Z"
                fill="white"
              />
              <path
                d="M7.29232 25.5C8.44291 25.5 9.37565 24.5673 9.37565 23.4167C9.37565 22.2661 8.44291 21.3333 7.29232 21.3333C6.14172 21.3333 5.20898 22.2661 5.20898 23.4167C5.20898 24.5673 6.14172 25.5 7.29232 25.5Z"
                fill="white"
              />
              <path
                d="M17.7083 25.5C18.8589 25.5 19.7917 24.5673 19.7917 23.4167C19.7917 22.2661 18.8589 21.3333 17.7083 21.3333C16.5577 21.3333 15.625 22.2661 15.625 23.4167C15.625 24.5673 16.5577 25.5 17.7083 25.5Z"
                fill="white"
              />
            </g>
            <defs>
              <clipPath id="clip0_148_824">
                <rect
                  width="25"
                  height="25"
                  fill="white"
                  transform="translate(0 0.500004)"
                />
              </clipPath>
            </defs>
          </svg>

          <div v-if="$parent.cartContents.length" class="indicator">
            {{ $parent.cartContents.length }}
          </div>
        </router-link>
        <router-link to="/profile" class="icon-button" v-if="$parent.isAuth">
          <svg
            width="25"
            height="26"
            viewBox="0 0 25 26"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clip-path="url(#clip0_148_405)">
              <path
                d="M12.5 13C13.7361 13 14.9445 12.6334 15.9723 11.9467C17.0001 11.2599 17.8012 10.2838 18.2742 9.14177C18.7473 7.99973 18.8711 6.74307 18.6299 5.53068C18.3888 4.3183 17.7935 3.20466 16.9194 2.33058C16.0453 1.4565 14.9317 0.861249 13.7193 0.620091C12.5069 0.378933 11.2503 0.502704 10.1082 0.975752C8.96619 1.4488 7.99007 2.24988 7.30331 3.27768C6.61656 4.30549 6.25 5.51387 6.25 6.75C6.25165 8.40709 6.91067 9.99584 8.08241 11.1676C9.25415 12.3393 10.8429 12.9983 12.5 13ZM12.5 2.58333C13.3241 2.58333 14.1297 2.8277 14.8149 3.28554C15.5001 3.74338 16.0341 4.39413 16.3495 5.15548C16.6649 5.91684 16.7474 6.75462 16.5866 7.56288C16.4258 8.37113 16.029 9.11356 15.4463 9.69628C14.8636 10.279 14.1211 10.6758 13.3129 10.8366C12.5046 10.9974 11.6668 10.9149 10.9055 10.5995C10.1441 10.2841 9.49338 9.75008 9.03554 9.06487C8.5777 8.37967 8.33333 7.57409 8.33333 6.75C8.33333 5.64493 8.77232 4.58512 9.55372 3.80372C10.3351 3.02232 11.3949 2.58333 12.5 2.58333Z"
                fill="white"
              />
              <path
                d="M12.5 15.0833C10.0144 15.0861 7.63147 16.0747 5.87392 17.8323C4.11636 19.5898 3.12776 21.9728 3.125 24.4583C3.125 24.7346 3.23475 24.9996 3.4301 25.1949C3.62545 25.3903 3.8904 25.5 4.16667 25.5C4.44293 25.5 4.70789 25.3903 4.90324 25.1949C5.09859 24.9996 5.20833 24.7346 5.20833 24.4583C5.20833 22.5245 5.97656 20.6698 7.34401 19.3023C8.71147 17.9349 10.5661 17.1667 12.5 17.1667C14.4339 17.1667 16.2885 17.9349 17.656 19.3023C19.0234 20.6698 19.7917 22.5245 19.7917 24.4583C19.7917 24.7346 19.9014 24.9996 20.0968 25.1949C20.2921 25.3903 20.5571 25.5 20.8333 25.5C21.1096 25.5 21.3746 25.3903 21.5699 25.1949C21.7653 24.9996 21.875 24.7346 21.875 24.4583C21.8722 21.9728 20.8836 19.5898 19.1261 17.8323C17.3685 16.0747 14.9856 15.0861 12.5 15.0833Z"
                fill="white"
              />
            </g>
            <defs>
              <clipPath id="clip0_148_405">
                <rect
                  width="25"
                  height="25"
                  fill="white"
                  transform="translate(0 0.5)"
                />
              </clipPath>
            </defs>
          </svg>
        </router-link>
        <button
          @click="$parent.logout()"
          class="icon-button"
          v-if="$parent.isAuth"
        >
          <img src="./../images/logout.svg" class="img" />
        </button>
        <div class="link-container" v-else>
          <button class="button stroke w-165" @click="$parent.openSignIn()">
            <span>Sign In</span>
          </button>
          <button class="button w-165" @click="$parent.openSignUp()">
            <span>Sign Up</span>
          </button>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
import Select2 from "vue3-select2-component";
export default {
  name: "Header",
  components: {
    Select2,
  },
  props: {
    currencyCodes: {
      type: Array,
      default: () => [],
    },
  },
  data: function () {
    return {};
  },
  methods: {
    changeCurrency(val) {
      this.$emit("update-currency", val);
      localStorage.setItem("currency", val);
    },
  },
};
</script>
